<template>
  <div class="reject-request">
    <div class="reject-request-header">
      <div class="reject-request-close">
        <div class="button-text">Fechar</div>
        <button @click="rejectClose"><div class="icon-close"></div></button>
      </div>
      <h2>Rejeitar pedido</h2>
    </div>
    <hr>
    <div class="reject-request-body">
      <label for="reason">
        Informe abaixo os motivos da rejeição
      </label>
      <textarea name="reason" placeholder="Descreva o motivo..." v-model="rejectComment"></textarea>
      <span>
        <label for="block"><input type="checkbox" v-model="showBlacklistPanel" name="block"> Bloquear usuário</label>
        <button v-if="!showBlacklistPanel" :disabled="validatedReject" @click="reject" :class="validatedReject ? 'btn-disabled' : ''">Confirmar</button>
      </span>
    </div>
    <hr v-if="showBlacklistPanel">
    <div class="reject-request-body" v-if="showBlacklistPanel">
      <h2 class="space">Bloqueio de usuário</h2>
      <label for="">
        Tempo de bloqueio
      </label>
      <select id="" v-model="blacklistPeriodSelected">
        <option v-for="(i, key) in blacklistPeriodOptions" v-bind:key="key" :value="i.value">
          {{ i.text }}
        </option>
      </select>
      <label for="block">
        Informa abaixo o motivo do bloqueio
      </label>
      <textarea name="block" placeholder="Descreva o motivo..." v-model="blacklistComment"></textarea>
      <span>
        <span></span>
        <button @click="addBlacklist" :disabled="validatedBlacklist" :class="validatedBlacklist ? 'btn-disabled' : ''">Confirmar</button>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      showBlacklistPanel: false,
      message: null,
      rejectComment: null,
      blacklistComment: null,
      blacklistPeriodSelected: null,
      blacklistPeriodOptions: [
        { value: null, text: 'Selecione o período' },
        { value: new Date().setDate(new Date().getDate() + 1), text: '1 Dia' },
        { value: new Date().setDate(new Date().getDate() + 7), text: '1 Semana' },
        { value: new Date().setDate(new Date().getDate() + 31), text: '1 Mês' }
      ]
    }
  },
  computed: {
    validatedBlacklist () {
      if (!this.blacklistPeriodSelected || !this.blacklistComment) {
        return true
      } else {
        return false
      }
    },
    validatedReject () {
      if (!this.rejectComment) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    rejectClose () {
      this.$emit('emitRejectClose')
    },
    reject () {
      this.$http.post('api/validations/' + this.$route.params.txid + '/reject', {comment: this.rejectComment})
        .then(function (res) {
          this.message = res.data.msg
          this.$emit('emit-reject-done', true)
          this.rejectClose()
        })
        .catch(function (res) {
          this.$bvToast.toast(res.body, {
            autoHideDelay: 5000,
            variant: 'danger'
          })
        })
        .then(function (res) {
          this.$http.post('api/transactions/' + this.$route.params.txid + '/notes', {message: this.rejectComment})
            .then(function (res) {
              this.$root.$emit('loadNotes')
            })
            .catch(function (res) {
              this.$bvToast.toast(res.body, {
                autoHideDelay: 5000,
                variant: 'danger'
              })
              console.log('Error')
            })
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
        })
    },
    addBlacklist () {
      this.$http.post('api/blacklist/' + this.$route.params.txid, {
        blacklistPeriod: new Date(this.blacklistPeriodSelected),
        cpf: this.customerCpf,
        phone: this.customerPhoneNumber,
        comment: this.blacklistComment,
        device: this.customerDevice,
        isBlacklist: true
      })
        .then(function (res) {
          this.$bvToast.toast('Adicionado com sucesso', {
            autoHideDelay: 5000,
            variant: 'success'
          })

          this.$emit('emit-reject-done', true)
          this.rejectClose()
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
          this.$bvToast.toast(res, {
            title: 'Erro ao adicionar na Blacklist',
            autoHideDelay: 5000,
            variant: 'danger'
          })
        })

      this.$http.post('api/validations/' + this.$route.params.txid + '/reject', {comment: this.blacklistComment})
        .then(function (res) {
          this.message = res.data.msg
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
        })
        .then(function (res) {
          this.$http.post('api/transactions/' + this.$route.params.txid + '/notes', {message: this.blacklistComment})
            .then(function (res) {
              this.$root.$emit('loadNotes')
            })
            .catch(function (res) {
              console.log('Error')
              console.log(res)
            })
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
        })
    }
  },
  props: ['customerDevice', 'customerCpf', 'customerPhoneNumber']
}
</script>

<style lang="scss" scoped>
  .reject-request {
    width: calc(30% - 20px);
    border-radius: 16px;
    margin-left: 20px;
    float: right;
    background-color: #FFFFFF;
    .reject-request-header {
      padding: 16px;
      .reject-request-close {
        display: flex;
        justify-content: flex-end;
        button {
          width: 24px;
          height: 24px;
          float: right;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 5px;
          margin-top: -4px;
          padding: 0px;
          border: none;
          background: rgba(66, 133, 244, 0.2);
          color: #4285F4;
          outline: none;
        }
        .button-text {
          float: right;
          line-height: 1.4em;
          color: rgba(66, 133, 244, 0.75);
          margin-right: 4px;
        }
      }
    }
    h2 {
      margin: 0;
      font-size: 16px;
      color: #666666;
      &.space {
        margin-bottom: 32px;
      }
    }
    .reject-request-body {
      padding: 24px;
      label {
        font-size: 12px;
        color: #666666;
        display: flex;
        align-items: center;
        float: left;
      }
      textarea {
        width: 100%;
        min-height: 128px;
        margin-bottom: 16px;
        padding: 16px;
        border: none;
        background-color: #F3F3F3;
      }
      select {
        width: 100%;
        height: 40px;
        border: none;
        margin-bottom: 36px;
        background-color: #f3f3f3;
      }
      span {
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        label {
          margin: 0;
          input[type="checkbox"] {
            width: 16px;
            height: 16px;
            background-color: #F3F3F3;
            margin-right: 8px;
          }
        }
        button {
          width: 100px;
          height: 32px;
          border-radius: 5px;
          border: none;
          float: right;
          background-color: #1c56e0;
          color: #ffffff;
        }
        .btn-disabled {
          background-color: #E5E5E5;
          color: #B0B0B0
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/partial/customer/RejectRequest.vue